import script from "./InstallConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./InstallConfirmModal.vue?vue&type=style&index=0&id=3fceafa8&lang=scss"

const __exports__ = script;

export default __exports__